import PriorityQueue from "./priorityQueue";
export class NewrelicPriorityQueue extends PriorityQueue {
    highestFrequencyElement() {
        const frequencyMap = new Map();
        this.queue.forEach((pageActions) => {
            pageActions?.forEach(([name]) => frequencyMap.set(name, (frequencyMap.get(name) || 0) + 1));
        });
        return [...frequencyMap.entries()].reduce((a, e) => (e[1] > (a?.[1] || 0) ? e : a), ["", 0]);
    }
}
//# sourceMappingURL=newrelicPriorityQueue.js.map